module.exports = __webpack_public_path__ + "img/3.38da2cff.jpg";